import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ff5ec19")

_pushScopeId("data-v-4ff5ec19")
const _hoisted_1 = { id: "entire_bus_component" }
const _hoisted_2 = { class: "search_ticket" }
const _hoisted_3 = { class: "search_container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title_container" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "search-eye-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_51",
      "data-name": "Path 51",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_52",
      "data-name": "Path 52",
      d: "M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Zm-2.006-.742a7,7,0,1,0-.15.15l.15-.15Zm-3.847-8.7a2,2,0,1,0,2.646,2.646,4,4,0,1,1-2.646-2.646Z",
      fill: "#1d2329"
    })
  ]),
  /*#__PURE__*/_createVNode("h2", null, "Search & book bus tickets")
], -1)
const _hoisted_5 = { class: "search_box_content_fields" }
const _hoisted_6 = { class: "search_box" }
const _hoisted_7 = { class: "locations" }
const _hoisted_8 = { class: "fields" }
const _hoisted_9 = { class: "field_child" }
const _hoisted_10 = { class: "row auto_complete" }
const _hoisted_11 = { class: "inputs" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "From:", -1)
const _hoisted_13 = {
  id: "autocomplete_results",
  class: "autocomplete-results"
}
const _hoisted_14 = {
  key: 0,
  class: "loading"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "row_separator" }, null, -1)
const _hoisted_16 = { class: "row auto_complete" }
const _hoisted_17 = { class: "inputs" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, "To:", -1)
const _hoisted_19 = {
  id: "autocomplete_results",
  class: "autocomplete-results"
}
const _hoisted_20 = {
  key: 0,
  class: "loading"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "route_icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "0 0 50 50"
  }, [
    /*#__PURE__*/_createVNode("g", {
      id: "exchange-line",
      transform: "translate(50) rotate(90)"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "Path_53",
        "data-name": "Path 53",
        d: "M0,0H50V50H0Z",
        fill: "none"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "Path_54",
        "data-name": "Path 54",
        d: "M25,48A23,23,0,1,1,48,25,23,23,0,0,1,25,48Zm0-4.6A18.4,18.4,0,1,0,6.6,25,18.4,18.4,0,0,0,25,43.4ZM13.5,27.3H34.2v4.6H25v6.9ZM25,18.1V11.2L36.5,22.7H15.8V18.1Z",
        transform: "translate(0 0)",
        fill: "#487fff"
      })
    ])
  ])
], -1)
const _hoisted_22 = { class: "book_search_actions" }
const _hoisted_23 = { class: "row_filter" }
const _hoisted_24 = /*#__PURE__*/_createVNode("option", { value: "" }, "Booking date", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("svg", {
  id: "filter-off-line",
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createVNode("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M0,0H30V30H0Z",
    fill: "none"
  }),
  /*#__PURE__*/_createVNode("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M8.234.515,27.07,18.606l-1.884,1.809-5.092-4.889-1.11,1.6V28H10.992V17.126L4.332,7.532H3V4.973H9.107L6.35,2.324Zm3.538,7.017H7.534l6.122,8.819v9.09H16.32v-9.09l1.854-2.67ZM26.977,4.973V7.532H25.645l-2.551,3.674L21.173,9.36l1.269-1.828H19.268L16.6,4.973Z",
    fill: "#575d62"
  })
], -1)
const _hoisted_26 = { class: "row_filter" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-1"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "available_tickets" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_available_tickets = _resolveComponent("available-tickets")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        name: "location",
                        placeholder: "Your location",
                        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeAutoCompleteOne())),
                        required: "",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ticket_departure = $event)),
                        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                        onKeydown: [
                          _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                          _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                          _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["prevent"]), ["enter"]))
                        ],
                        autocomplete: "off"
                      }, null, 544), [
                        [_vModelText, _ctx.ticket_departure]
                      ])
                    ]),
                    _withDirectives(_createVNode("ul", _hoisted_13, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock("li", _hoisted_14, " loading . . . "))
                        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.results, (result, i) => {
                            return (_openBlock(), _createBlock("li", {
                              key: i,
                              onClick: ($event: any) => (_ctx.setResult(result)),
                              class: ["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]
                            }, _toDisplayString(result), 11, ["onClick"]))
                          }), 128))
                    ], 512), [
                      [_vShow, _ctx.isOpen]
                    ])
                  ]),
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createVNode("input", {
                        id: "destination",
                        type: "text",
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.removeAutoCompleteTwo())),
                        name: "destination",
                        placeholder: "Your destination",
                        required: "",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.ticket_destination = $event)),
                        onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangeTwo && _ctx.onChangeTwo(...args))),
                        onKeydown: [
                          _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDownTwo && _ctx.onArrowDownTwo(...args)), ["down"])),
                          _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUpTwo && _ctx.onArrowUpTwo(...args)), ["up"])),
                          _cache[12] || (_cache[12] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnterTwo && _ctx.onEnterTwo(...args)), ["prevent"]), ["enter"]))
                        ],
                        autocomplete: "off"
                      }, null, 544), [
                        [_vModelText, _ctx.ticket_destination]
                      ])
                    ]),
                    _withDirectives(_createVNode("ul", _hoisted_19, [
                      (_ctx.isLoadingTwo)
                        ? (_openBlock(), _createBlock("li", _hoisted_20, " loading . . . "))
                        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.resultsTwo, (resultTwo, i) => {
                            return (_openBlock(), _createBlock("li", {
                              key: i,
                              onClick: ($event: any) => (_ctx.setResultTwo(resultTwo)),
                              class: ["autocomplete-result", { 'is-active': i === _ctx.arrowCounterTwo }]
                            }, _toDisplayString(resultTwo), 11, ["onClick"]))
                          }), 128))
                    ], 512), [
                      [_vShow, _ctx.isOpenTwo]
                    ])
                  ])
                ])
              ]),
              _hoisted_21
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.booking_date = $event))
                }, [
                  _hoisted_24,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.Search.search_booking_dates, (date, index) => {
                    return (_openBlock(), _createBlock("option", {
                      key: index,
                      value: date
                    }, _toDisplayString(date), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.booking_date]
                ]),
                _hoisted_25
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("button", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.SearchTicket()))
                }, [
                  (_ctx.searching)
                    ? (_openBlock(), _createBlock("span", _hoisted_27))
                    : _createCommentVNode("", true),
                  (!_ctx.searching)
                    ? (_openBlock(), _createBlock("span", _hoisted_28, "Search ticket"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_29, [
      _createVNode(_component_available_tickets, { allTickets: _ctx.allTickets }, null, 8, ["allTickets"])
    ])
  ]))
})